// extracted by mini-css-extract-plugin
export default {"downloadConetentMain":"downloadContent_downloadConetentMain__pSgl-"};